import React from "react";
import Header from "../../components/Header";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { Typography } from "@material-ui/core";
import LoginInput from "../../components/LoginInput";
import { useSelector } from "react-redux";
import { Redirect } from "react-router";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    paddingTop: "64px",
  },
  header: {
    fontFamily: "Work Sans, sans-serif",
    fontWeight: 600,
    color: "#000",
    textAlign: "left",
    fontSize: "36px",
    "@media (max-width: 900px)": {
      fontSize: "18px",
    },
  },
  subHeader: {
    fontSize: "20px",
    "@media (max-width: 900px)": {
      fontSize: "12px",
    },
  },
}));

const Login = () => {
  const { root, header, subHeader } = useStyles();
  const auth = useSelector((state) => state.auth);
  if (auth.authenticate) {
    return <Redirect to={`/app`} />;
  }
  return (
    <div className={root}>
      <Grid container spacing={8} direction="column">
        <Grid item xs={12}>
          <Header />
        </Grid>
        <Grid item container>
          <Grid item xs={2} />
          <Grid item xs={8}>
            <Paper elevation={0}>
              <Typography variant="h6" className={header} component="h1">
                Capchain Account Login
              </Typography>
              <Typography variant="subtitle1" className={subHeader}>
                Welcome back! Log In with your Email
              </Typography>
              <LoginInput checkRemember />
            </Paper>
          </Grid>
          <Grid item xs={2} />
        </Grid>
        <Grid
          container
          justifyContent="center"
          alignItems="flex-end"
          item
          xs={12}
        >
          <footer>
            <Typography variant="caption">
              &#169;2022 Ethlink.tech .All rights reserved
            </Typography>
          </footer>
        </Grid>
      </Grid>
    </div>
  );
};

export default Login;
